function parseHostname(host) {
    if (typeof window === 'undefined') {
        return {
            projectDomain: 'interaktiv.tagesanzeiger.ch',
            publicationDomain: 'tagesanzeiger.ch',
            publicationName: 'tagesanzeiger' 
        };
    }
    if (host === void 0) { host = window.location.hostname; }
    if (/[/:]/.test(host)) {
        host = new window.URL(host).hostname;
    }
    var projectDomain = /localhost$/.test(host)
        ? 'interaktiv.tagesanzeiger.ch'
        : host;
    var hostnameArray = projectDomain.split('.');
    var publicationDomain = hostnameArray.slice(-2).join('.');
    var publicationName = hostnameArray[hostnameArray.length - 2];
    return {
        projectDomain: projectDomain,
        publicationDomain: publicationDomain,
        publicationName: publicationName
    };
}

export { parseHostname as default, parseHostname };
//# sourceMappingURL=index.js.map
